export default __webpack_public_path__ + "static/media/Typescript.17936c69.png";